import { createStore, applyMiddleware, compose } from 'redux'; 
import createSagaMiddleware from 'redux-saga';
import rootSaga from './saga/rootSaga';
import {reducer} from './reducer/reducer';
const sagaMiddleware = createSagaMiddleware();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware));

const store = createStore(
  reducer,
  enhancer
);

sagaMiddleware.run(rootSaga);

export {store as default};